import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { previewAppUrl } from '../../_services/preview-return-url';
import { environment } from 'environments/environment';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-draft-mode',
    template: `
  <button mat-flat-button color="accent" (click)="launchDraftMode()">Launch Preview</button>
  `,
    styles: [],
    imports: [MatButton]
})
export class DraftModeComponent {

  constructor(
    private route: ActivatedRoute,
    public auth: AuthService
  ) { }

  async launchDraftMode() {
    const schoolId =
      this.route.snapshot.paramMap.get('schoolId') ??
      this.route.snapshot.parent?.paramMap.get('schoolId') ??
      '';
    const user = await this.auth.currentUser();
    if (!user || !schoolId) {
      return;
    }
    const supportLogin = await this.auth.prepareMicrosoftPreviewTab();
    window.open(previewAppUrl({
      pageOrigin: window.location.origin,
      configuredBase: environment.previewUrl,
      schoolId,
      supportLogin
    }), '_blank', 'noopener');
  }
}
